// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  dialog: {
    '& .MuiDialog-paper': {
      width: '30rem',
    },
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
  },
  dialogTitle: {
    fontWeight: 600,
    fontSize: '20px',
    padding: 0,
    textTransform: 'none',
  },
  dialogContent: {
    padding: theme.spacing(2, 3),
    paddingTop: 0,
  },
  dialogText: {
    marginBottom: theme.spacing(2),
  },
  buttonProgress: {
    color: '#777777',
  },
  actionButtons: {
    padding: theme.spacing(1, 3),
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
  },
  textField: {
    '& .MuiFormHelperText-root': {
      marginLeft: 0,
    },
  },
});

export default styles;
